<template>
  <div>

    <Carousel />
    <!-- Start About Us Area -->

    <section class="features">
      <div class="container-fluid">
        <div class="single-head">
          <div class="row">
            <div class="col-lg-3 col-md-6 col-12 padding-zero">
              <div class="single-feature">
                <h4 class="wow fadeInUp" data-wow-delay=".4s">We Build, Fund, Spin Out Innovative Solutions, and
                  Commercialize Research</h4>
                <p class="wow fadeInUp" data-wow-delay=".2s">We are building a crowdsourced ecosystem where we connect
                  researchers, innovators and founders to one
                  another, to talents, mentors, co-building teams and great investments, so as to build, grow and scale
                  market-creating innovations.</p>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-12 padding-zero">
              <div class="single-feature">
                <h4 class="wow fadeInUp" data-wow-delay=".4s">We Are Working With Great People, Creating An
                  Innovation-As-A-Service Platform</h4>
                <p class="wow fadeInUp" data-wow-delay=".2s">We have a great core team and an amazing pool of talents
                  who co-build with founders and work on our
                  internal ideas.</p>
                <div class="wow button fadeInUp" data-wow-delay=".2s">
                  <router-link to="/team" class="btn">Meet Our
                    Core Team <i class="lni lni-arrow-right"></i></router-link>
                </div>
              </div>
            </div>

<div class="col-lg-3 col-md-6 col-12 padding-zero">
              <div class="single-feature">
                <h4 class="wow fadeInUp" data-wow-delay=".4s">We Are Connecting Researchers to All Resources they Need</h4>
                <p class="wow fadeInUp" data-wow-delay=".2s"> We have created platforms and a large marketplace of equipment, funders, investment, organizations, institutions and businesses to take their research to market.</p>
                 <div class="wow button fadeInUp" data-wow-delay=".2s">
                  <a href="https://community.tribinnovafrica.com" target="_blank" class="btn"> Join the community here <i class="lni lni-arrow-right"></i></a>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-12 padding-zero">
              <div class="single-feature">
                <h4 class="wow fadeInUp" data-wow-delay=".4s">We Are Building A Tribe, And The Core Pillars Of
                  Innovation</h4>
                <p class="wow fadeInUp" data-wow-delay=".2s">We believe that scientific R&D, commercialization, venture
                  building and funding form the pillars of
                  innovation.</p>
                <p class="wow fadeInUp" data-wow-delay=".2s">We have created a transparent network and infrastructure to
                  power these three arms, to enable
                  diaspora, individual and corporate investments in African Research and African Startups, in traceable
                  manner. </p>
                <div class="wow button fadeInUp" data-wow-delay=".2s">
                  <a href="https://app.tribinnovafrica.com/register?type=investor" target="_blank" class="btn">Join The
                    Tribe Of Funders <i class="lni lni-arrow-right"></i></a>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-12 padding-zero">
              <div class="single-feature last">
                <h4 class="wow fadeInUp" data-wow-delay=".4s">Market-creating, and High-Level Adoption Innovations Are
                  Our Focus</h4>
                <p class="wow fadeInUp" data-wow-delay=".2s">We are opening up large interconnected markets, solving
                  problems of high frequency and high
                  density.
                </p>
                <p class="wow fadeInUp" data-wow-delay=".2s">We are open to innovations, founders who dare challenge the
                  norm, and investors able to take high
                  risks in startups and we seek talents willing to build disruptive solutions, pursue careers with
                  global brands coming out of Africa.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="heading-underline"></div>

    <section class="features">
      <div class="container-fluid">
        <div class="single-head">
          <div class="row">
            <div class="col-lg-4 col-md-4 col-12 padding-zero">
              <div class="single-feature">
                <h4 class="wow fadeInUp" data-wow-delay=".4s">Do You Want To Support African Innovative Research?</h4>
                <div class="button wow fadeInUp" data-wow-delay=".2s">
                  <a href="https://app.tribinnovafrica.com/register?type=research" target="_blank" class="btn">Register
                    Your Research <i class="lni lni-arrow-right"></i></a>
                  <a href="https://app.tribinnovafrica.com/projects" target="_blank" class="btn mt-2">Browse
                    Research Projects <i class="lni lni-arrow-right"></i></a>
                  <a href="https://app.tribinnovafrica.com/register?type=lab" target="_blank" class="btn mt-2">Register
                    A Lab or Facility <i class="lni lni-arrow-right"></i></a>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-12 padding-zero">
              <div class="single-feature">
                <h4 class="wow fadeInUp" data-wow-delay=".2s">Want To Access and Fund Great Research and Startups?</h4>
                <p class="mb-4">Join the <b>Investment Group</b> </p>
                <div class="button">
                  <a href="https://app.tribinnovafrica.com/register?type=investor" target="_blank" class="btn">Request
                    Invite Code<i class="lni lni-arrow-right"></i></a>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-12 padding-zero">
              <div class="single-feature last">
                <h4> Are You An Innovation-Minded Talent In Tech & Engineering?</h4>
                <p>Our startups and researchers need you.</p>
                <div class="button">
                  <a href="https://airtable.com/shru3Xa8FUqvfgLlV" target="_blank" class="btn">Join
                    The Innotals <i class="lni lni-arrow-right"></i></a>
                </div>
              </div>
            </div>
            <div class="col-lg-12 col-md-4 col-12 padding-zero text-center">
              <div class="single-feature last">
                <h4>Are You A Founder or Team Wanting Us To Build With You?</h4>
                <div class="button">
                  <a href="https://app.tribinnovafrica.com/register?type=research" target="_blank" class="btn">Register
                    Your Startup or Team <i class="lni lni-arrow-right"></i></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="about-us section">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-12">
            <div class="about-left">
              <div class="about-title align-left">
                <h2 class="wow fadeInUp" data-wow-delay=".4s">Our Industries</h2>   
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-12">
            <div class="about-right wow fadeInRight" data-wow-delay=".4s">
              <img src="/assets/img/landing/industries.png" alt="#">
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import Carousel from '../../components/Carousel.vue';

  export default {
    name: 'Home',
    components: {
      Carousel
    },
    metaInfo: {
      title: "Tribinnov Africa - The Tribe Of Innovation",
      meta: [
        {
          name: "description", content: "Join us and be the pioneer of the next wave of scientific and business research, innovation or idea in Africa."
        },
        { name: "keywords", content: "investment, finance, tribinnov, tribinnov africa, tribe of innovation, tribe, africa, nigeria, funding, crowdfunding, fundraiser" }
      ]
    }
  };
</script>
